import ReviewsListInfoServiceBase from "@apps/reviews/services/ReviewsListInfoServiceBase";

class ReviewsListInfoService extends ReviewsListInfoServiceBase {}

export default ReviewsListInfoService;
